import type { FC } from 'react';

type DnaImageChoiceCardProps = {
  image: string;
  label: string;
  description?: string;
  selected: boolean;
  dimmed?: boolean;
  disabled?: boolean;
  onClick: () => void;
};

const DnaImageChoiceCard: FC<DnaImageChoiceCardProps> = ({
  image,
  label,
  description,
  selected,
  dimmed = false,
  disabled = false,
  onClick,
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-pressed={selected}
      className={`relative h-[210px] overflow-hidden rounded-[18px] border text-left transition-[transform,box-shadow,border-color,opacity] duration-500 ease-[cubic-bezier(.22,1,.36,1)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[var(--gold)] ${
        selected
          ? 'border-[var(--gold)] shadow-[0_12px_30px_rgba(201,168,76,0.25)]'
          : 'border-white/10'
      } ${dimmed ? 'opacity-60' : 'opacity-100'} disabled:cursor-not-allowed hover:-translate-y-1 hover:opacity-100 hover:shadow-[0_12px_30px_rgba(0,0,0,0.35)]`}
    >
      <img src={image} alt="" className="h-full w-full object-cover" />
      <span className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/10 to-transparent" />

      <span className="absolute bottom-3 left-3 right-10 text-white">
        <span className="block font-feature text-xl font-semibold leading-tight">
          {label}
        </span>
        {description ? (
          <span className="mt-0.5 block font-feature text-sm leading-tight">
            {description}
          </span>
        ) : null}
      </span>

      {selected ? (
        <span
          className="absolute right-3 top-3 flex h-7 w-7 items-center justify-center rounded-full bg-[var(--gold)] font-sans text-sm font-semibold text-[var(--ink)] shadow-md"
          aria-hidden="true"
        >
          ✓
        </span>
      ) : null}
    </button>
  );
};

export default DnaImageChoiceCard;
